export const ROUTES = {
  home: "/sales-enablement/products",
  create: "/sales-enablement/products/new",
  update: (id: string) => `/sales-enablement/products/${id}`,
};

export const QUERY_KEYS = {
  fetchProducts: "fetchProducts",
};
